export enum TableColumnActions {
  INSERT_LEFT = 'Insert column left',
  INSERT_RIGHT = 'Insert column right',
  DELETE = 'Delete column',
}

export enum TableRowActions {
  INSERT_ROW_BELOW = 'Insert row below',
  INSERT_ROW_ABOVE = 'Insert row above',
  DELETE = 'Delete row',
}

export enum TableCellsActions {
  SPLIT_CELL_ROW = 'Split cell to row',
  SPLIT_CELL_COLUMN = 'Split cell to column',
  MERGE_CELLS = 'Merge cells',
}
